import React, { useEffect, useState } from "react";
import OrderCard from "./OrderCard";
import AccountDetails from "./AccountDetails";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/features/auth/authSlice";
import { getOrders } from "../../redux/features/order/orderSlice";

const Profile = () => {
  const [activeNav, setActiveNav] = useState("order");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { orders, isLoading } = useSelector((state) => state.orders);

  // const { name, bio, email, avatar, role } = user;
  const name = user?.name;
  const bio = user?.bio;
  const email = user?.email;
  const avatar = user?.bio;
  const role = user?.role;

  const logoutHandler = () => {
    dispatch(logout());
    navigate("/");
  };

  const [names, setName] = useState("");
  const [bios, setBio] = useState("");
  const [roles, setRole] = useState("");
  const [emails, setEmail] = useState("");
  const [avatars, setAvatar] = useState(""); ///////////////////////////////////////////////////

  useEffect(() => {
    dispatch(getOrders());

    if (user) {
      setName(user.name || "");
      setEmail(user.email || "");
      setBio(user.bio || "");
      setAvatar((user.avatar && user.avatar.url) || "");
      setRole(user.role || "");
    }

    if (!user || user === null) {
      navigate("/login");
    }

    if (roles === "admin") {
      navigate("/admin");
    }
  }, [user, navigate, roles, dispatch]);

  if (!user) {
    return <div>Loading...</div>; // Or any loading indicator or redirect logic
  }

  const order = true;

  return (
    <div className="bg-gray-100s bg-slate-200 min-h-screen  px-[10px] md:px-[20px] lg:px-[3%] pt-5">
      <div className="w-full   flex flex-col md:flex-row ">
        {/* nav */}
        <div className=" w-fit p-5   ">
          <h1 className="text-3xl font-semibold mb-6">My Profile</h1>
          <div className="flex items-center mb-6">
            <img
              src={`${avatars}`}
              alt="Profile"
              className="w-16 h-16 rounded-full mr-4"
            />
            <div>
              <h2 className="text-xl font-semibold">{names}</h2>
              <p className="text-gray-600">{emails}</p>
              <p className="text-gray-700">{bios}</p>
            </div>
          </div>
          <div className="my-3">
            <button
              className="bg-red-500 font-bold text-white px-3 py-1 rounded-md"
              onClick={logoutHandler}
            >
              Logout
            </button>
          </div>
        </div>
        {/* info */}
        <div className=" md:border-l border-slate-400 pl-3 flex-1">
          <div>
            <ul className=" flex flex-row items-center [&>*]:font-semibold ">
              <li
                onClick={() => setActiveNav("order")}
                className={`cursor-pointer ${
                  activeNav === "order" && "border-b border-orange-500"
                } mr-2`}
              >
                Order List
              </li>
              <li
                onClick={() => setActiveNav("account")}
                className={`cursor-pointer ${
                  activeNav === "account" && "border-b border-orange-500"
                } mr-2`}
              >
                Account Details
              </li>
            </ul>
          </div>
          {activeNav === "order" && (
            <>
              {isLoading ? (
                <h1 className=" text-center">Loading...</h1>
              ) : (
                <>
                  {!order ? (
                    <div className="mt-5">
                      <h2 className="text-xl font-semibold mb-4">
                        No Order found
                      </h2>
                    </div>
                  ) : (
                    <div className="mt-5">
                      <h2 className="text-xl font-semibold mb-4">
                        Recent Orders
                      </h2>
                      <div className="order-list ">
                        {orders.map((order) => (
                          <OrderCard
                            title={order.items[0].name}
                            image={order.items[0].image}
                            date={order.createdAt}
                            status={order.status}
                            amount={order.amount}
                            id={order._id}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
          {activeNav === "account" && (
            <AccountDetails name={name} email={email} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
